export var CATALOG_EMPTY_STATE_TRANSLATION_KEY = 'CATALOG_EMPTY_STATE';